import { Route, Routes, useLocation } from "react-router"
import './App.css';
import Header from "./components/Header"
import GalleryPage from "./components/GalleryPage"

function App() {
  const location = useLocation();

  return (
    <div className="App flex justify-center w-full">
        <div className='max-w-[1244px]  w-full'>
          <Routes  location={location} key={location.pathname}>
            <Route exact path='/' element={<Header/>} />
            <Route exact path="gallery" element={<GalleryPage />}/>
          </Routes>
        </div>
    </div>
  );
}

export default App;